module.exports = __webpack_public_path__ + "8b94fd47d7d6a47904c6237a58a53a11.jpg";